export class Wcag {
  activated?: boolean;
}
